import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import 'react-quill/dist/quill.snow.css'; // ES6
import { multiLineText } from '../../../../common/RegexValidation';
import TextEditor from '../../../../common/TextEditor';

var moment = require('moment');

class CreateAndEditIssue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            issue: '',
            recommendedActions: ''
        }
        this.createIssue = this.createIssue.bind(this)
    }

    close = () => {
        if (this.props.issueClickStatus === "createIssue") {
            this.setState({
                issue: '',
                recommendedActions: '',
            })
        }
        else if (this.props.issueClickStatus === "editIssue") {
            this.setState({
                issue: this.state.issue,
                recommendedActions: this.state.recommendedActions,
            })
        }
        this.props.issueClick(false, this.props.issueClickStatus)
    }
    createIssue(formData) {
        if (this.props.issueClickStatus === "createIssue") {
            let issueObject = {
                issue: this.state.issue,
                recommendedActions: this.state.recommendedActions,
                accountUserId: this.props.user._id,
                issueDate: moment(),
                issueStatus: 0
            }
            if (!this.props.selectedActivityData.issueLogComments) {
                this.props.selectedActivityData.issueLogComments = []
            }
            this.props.selectedActivityData.issueLogComments.unshift(issueObject);
            this.props.selectedActivityData.issueFlag = true;
            this.props.selectedActivityData.string = "createAnIssue";
            if (this.props.activeTab === "myactivities") {
                dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            }
            else {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
            this.close();
        }

        else if (this.props.issueClickStatus === "editIssue") {
            let index = this.props.selectedActivityData.issueLogComments.findIndex(x => x._id === this.props.currentNote._id);
            let issueObject = {
                _id: this.props.currentNote._id,
                issue: this.state.issue,
                recommendedActions: this.state.recommendedActions,
                accountUserId: this.props.currentNote.accountUserId,
                issueDate: moment(),
                issueStatus: 0
            }
            this.props.selectedActivityData.issueLogComments[index] = issueObject;
            if (this.props.activeTab === "myactivities") {
                dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
            }
            else {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
            this.close();
        }

    }

    updateText = (data, name) => {
        if (name === "Issue") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ issue: '' })
            } else {
                this.setState({ issue: data })
            }
        }

        if (name === "Recommended Actions") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ recommendedActions: '' })
            } else {
                this.setState({ recommendedActions: data })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.currentNote.issue !== nextProps.currentNote.issue) {
            this.setState({ issue: nextProps.currentNote.issue })
        }

        if (this.props.currentNote.recommendedActions !== nextProps.currentNote.recommendedActions) {
            this.setState({ recommendedActions: nextProps.currentNote.recommendedActions })
        }
        if (nextProps.issueClickStatus === "createIssue") {
            this.setState({
                issue: '',
                recommendedActions: ''
            })
        }
        else if (nextProps.issueClickStatus === "editIssue") {
            this.setState({
                issue: nextProps.currentNote.issue,
                recommendedActions: nextProps.currentNote.recommendedActions
            })
        }
    }


    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                className="issueModal basicModal"
                open={this.props.issueModalOpenFlag}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
                closeIcon
                onClose={this.close}
            >
                <Modal.Header>{this.props.issueClickStatus === "editIssue" ?
                    "Edit Issue"
                    :
                    " Create Issue"
                }</Modal.Header>
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="issue"
                    id="issueid"
                    onValidSubmit={this.createIssue}
                >
                    <Modal.Content className="pad_20">
                        <span className="head"> {this.props.selectedActivityData ? this.props.selectedActivityData.name : ''}</span>
                        <TextEditor
                            name="Issue"
                            text={this.state.issue}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />

                        <TextEditor
                            name="Recommended Actions"
                            text={this.state.recommendedActions}
                            type="textarea"
                            onChangeText={this.updateText}
                        />
                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button
                            content='Cancel'
                            className="button-cancel"
                            onClick={this.close} />
                        {this.props.issueClickStatus === "editIssue" ?
                            <Button
                                type="submit"
                                content='Update'
                                disabled={!this.state.issue || (this.state.issue && this.state.issue.length === 0)}
                                className="button-submit" /> :
                            <Button
                                type="submit"
                                content='Create'
                                disabled={!this.state.issue || (this.state.issue && this.state.issue.length === 0)}
                                className="button-submit" />}
                    </Modal.Actions>
                </Form >
            </Modal>

        )
    }
}
export default CreateAndEditIssue;